import TicketsActivityDetailGeneralInfo from "./TicketsActivityDetailGeneralInfo";
export default TicketsActivityDetailGeneralInfo;
